import svListingPost from '../locales/sv/listingPost.json';
import enListingPost from '../locales/en/listingPost.json';
import { getLanguage, type Language } from '@/utils/languageUtils';

const getListingPostLocale = (lang?: Language) => {
  const l = lang || getLanguage();
  return l === 'en' ? enListingPost : svListingPost;
};

export const listingPostLabels = (lang?: Language) => getListingPostLocale(lang);
